import { render, staticRenderFns } from "./InternetConnectionCheck.vue?vue&type=template&id=87a3653e&"
import script from "./InternetConnectionCheck.vue?vue&type=script&lang=js&"
export * from "./InternetConnectionCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports